<template>
  <div class="wrapper">
    <div class="clause-wrap">
      <header class="top-head border-1px">
        <h1>Email</h1>
      </header>
       <div class="empty border-1px"></div>
        <div class="emailInfo">
            <mt-field label="Email" placeholder="" v-model.trim="email" ></mt-field>
        </div>
        <div class="sendmailwrap">
            <mt-button :disabled="btnDisable" type="default" :class="!email? '': 'active'" @click.native="handleSend">Send</mt-button>
        </div>
    </div>


    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import INTERFACE from '@/interface'
import { Field, Button, Header, Toast, Indicator } from 'mint-ui';
// import { Button } from 'mint-ui';

Vue.component(Header.name, Header)
Vue.component(Button.name, Button);
Vue.component(Field.name, Field);
// Vue.use(Field)
export default {
  data() {
    return {
      I18n: window.I18n,
      email: '',
      policyNo: '',
      btnDisable: false
    };
  },
  methods: {
    handleSend() {
      var mailReg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      var isLegal = mailReg.test(this.email)
      if (!isLegal) {
        Toast({
          message: 'Please enter the correct email format',
          iconClass: 'icon icon-error'
        });
      }
      if (isLegal) {
        Indicator.open({
          text: 'Sending...',
          spinnerType: 'fading-circle'
        });
        this.btnDisable = true
        INTERFACE.getPolicyeBook({ policyId: this.policyId, receiverEmail: this.email }).then((data) => {
          this.btnDisable = false
          Indicator.close();
          if (data.error === 'SUCCESS') {
            this.$router.push({
              name: 'SendSuccess',
              query: { policyId: this.policyId }
            })
          } else {
            Toast({
              message: 'Send mail fail!',
              iconClass: 'icon icon-error'
            });
          }
        })
      }
    }
  },
  created() {
    this.policyId = this.$route.query.policyId
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import "./style/index.styl";
</style>



// WEBPACK FOOTER //
// src/pages/SendEmail/index.vue